import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig } from '@spartacus/core';
import { PageComponentModule } from '../../../cms-structure';
import { provideDefaultConfig } from '../../../core/config';
import { I18nModule } from '../../../core/i18n';
import { LinkCollectionComponent } from './link-collection.component';

@NgModule({
  imports: [CommonModule, PageComponentModule, I18nModule],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        CMSLinkCollectionComponent: { component: LinkCollectionComponent },
      },
    }),
  ],
  declarations: [LinkCollectionComponent],
  exports: [LinkCollectionComponent],
})
export class CmsLinkCollectionModule {}
